// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"4605a8ed","251":"b1e413f1"}[chunkId] + ".chunk.css";
};